module.exports = __webpack_public_path__ + "img/6.c0150c43.webp";